module.exports = __webpack_public_path__ + "static/media/exc_gro_fra_sec.76996db0.png";